// prettier-ignore-start
import "./instrument";
// prettier-ignore-end

import { applyGoogleTranslateFix } from "./lib/googleTranslateFix";

applyGoogleTranslateFix();

import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import { client } from "./client/client.gen";
import { HttpError } from "./http-error";
import "./i18n";
import { RootRecoverableErrorBoundary } from "./components/root-error-boundary";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import reportWebVitals from "./reportWebVitals";

client.interceptors.response.use(async (response) => {
  const statusCategory = response?.status.toString()[0];

  switch (statusCategory) {
    case "4": {
      throw new HttpError(response.status, response.statusText, response.url);
    }
    case "5": {
      throw new HttpError(response.status, response.statusText, response.url);
    }
  }

  return response;
});

const rootElement = document.getElementById("app")!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(
    <RootRecoverableErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{ queryClient }} />
      </QueryClientProvider>
    </RootRecoverableErrorBoundary>
  );
}

reportWebVitals();
